import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import ScottsdaleHeroSection from "./components/HeroSection";
import ScottsdaleStickyNav from "./components/StickyNav";
import ScottsdaleProcessingTimeSection from "./components/ProcessingTimeSection";
import ScottsdaleServicesSection from "./components/ServicesSection";
import ScottsdaleLocalAreaSection from "./components/LocalAreaSection";
import ScottsdaleTravelTimingSection from "./components/TravelTimingSection";
import ScottsdaleDestinationsSection from "./components/DestinationsSection";
import ScottsdaleTestimonialsSection from "./components/TestimonialsSection";
import ScottsdaleAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ScottsdaleComparisonSection from "./components/ComparisonSection";
import ScottsdaleMistakesSection from "./components/MistakesSection";
import ScottsdaleHowItWorksSection from "./components/HowItWorksSection";
import ScottsdaleFAQSection, { faqs } from "./components/FAQSection";
import ScottsdaleHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import ScottsdaleFinalCTA from "./components/FinalCTA";

export default function ScottsdalePage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Scottsdale"
        state="Arizona"
        stateAbbr="AZ"
        route="/cities/scottsdale"
        title="Emergency Passport Scottsdale, AZ — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Scottsdale, AZ — as fast as 24 hours. Reserved courier processing for Mayo Clinic physicians, Barrett-Jackson collectors, resort executives, and Scottsdale residents. A+ BBB rated, registered State Dept. courier. No LA agency drive required."
        geoPlacename="Scottsdale, Arizona"
        geoPosition="33.4942;-111.9261"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Arizona"
        statePageRoute="/states/arizona"
      />
      <ScottsdaleHeroSection />
      <ScottsdaleStickyNav />
      <ScottsdaleProcessingTimeSection />
      <ScottsdaleServicesSection />
      <ScottsdaleLocalAreaSection />
      <ScottsdaleTravelTimingSection />
      <ScottsdaleDestinationsSection />
      <ScottsdaleTestimonialsSection />
      <ScottsdaleAcceptanceFacilitiesSection />
      <ScottsdaleComparisonSection />
      <ScottsdaleMistakesSection />
      <ScottsdaleHowItWorksSection />
      <ScottsdaleFAQSection />
      <ScottsdaleHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/scottsdale" state="AZ" />
      <ScottsdaleFinalCTA />
    </div>
  );
}